/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { graphql, type GraphQLResponseResolver, type RequestHandlerOptions } from 'msw'
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An object scalar */
  Object: { input: any; output: any; }
};

export const AspectRatio = {
  FOUR_THREE: 'FOUR_THREE',
  NINE_SIXTEEN: 'NINE_SIXTEEN',
  SIXTEEN_NINE: 'SIXTEEN_NINE'
} as const;

export type AspectRatio = typeof AspectRatio[keyof typeof AspectRatio];
export const AssetCategory = {
  ALL: 'ALL',
  INTERNAL: 'INTERNAL',
  SPRTY: 'SPRTY',
  TEAM: 'TEAM'
} as const;

export type AssetCategory = typeof AssetCategory[keyof typeof AssetCategory];
export type AudioRendition = {
  name: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Float']['input']>;
  priority: Scalars['Int']['input'];
};

export type AudioTrack = {
  __typename?: 'AudioTrack';
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  renditionName: Scalars['String']['output'];
  trackType: Scalars['String']['output'];
};

export type Captions = {
  __typename?: 'Captions';
  language?: Maybe<Scalars['String']['output']>;
};

export type CaptionsInput = {
  language?: InputMaybe<Scalars['String']['input']>;
};

export type CerebroEventInfo = {
  __typename?: 'CerebroEventInfo';
  assetId: Scalars['Int']['output'];
  assetName: Scalars['String']['output'];
  blurb?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feedType?: Maybe<Scalars['String']['output']>;
  gamePk?: Maybe<Scalars['Int']['output']>;
  playbackUrl?: Maybe<Scalars['String']['output']>;
  programEndTime?: Maybe<Scalars['String']['output']>;
  programStartTime?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CerebroEventType = {
  __typename?: 'CerebroEventType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ClipOption = {
  __typename?: 'ClipOption';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ClipOptionInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export const ClipOutputType = {
  GIF: 'GIF',
  HLS: 'HLS',
  MP4: 'MP4'
} as const;

export type ClipOutputType = typeof ClipOutputType[keyof typeof ClipOutputType];
export type ClipOutputTypeResponse = {
  __typename?: 'ClipOutputTypeResponse';
  clipId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  linksByType: Array<Maybe<LinkByType>>;
  outputTypes?: Maybe<Array<Maybe<ClipOutputType>>>;
};

export type ClipRequestInput = {
  clippyFeedType?: InputMaybe<ClippyFeedType>;
  options: Array<InputMaybe<ClippyClipOption>>;
  outputType?: InputMaybe<ClipOutputType>;
  outputTypes?: InputMaybe<Array<InputMaybe<ClipOutputType>>>;
  plays: Array<InputMaybe<ClippyPlayInput>>;
  preferences?: InputMaybe<Array<InputMaybe<ClippyClipPreferenceInput>>>;
  requestIdOverride?: InputMaybe<Scalars['String']['input']>;
  transitions?: InputMaybe<Array<InputMaybe<VideoTransitionInsertInput>>>;
};

export type ClipResponse = {
  __typename?: 'ClipResponse';
  clipOutputType: ClipOutputType;
  durationInSeconds: Scalars['Float']['output'];
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
  thumbnails: Array<Maybe<ClippyThumbnail>>;
  uri: Scalars['String']['output'];
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  width: Scalars['Int']['output'];
};

export const ClippyClipOption = {
  ADD_MLB_WATERMARK: 'ADD_MLB_WATERMARK',
  CROP_FOUR_FIVE: 'CROP_FOUR_FIVE',
  CROP_NINE_SIXTEEN: 'CROP_NINE_SIXTEEN',
  CROP_ONE_ONE: 'CROP_ONE_ONE',
  CROSS_FADE: 'CROSS_FADE',
  GENERATE_SINGLE_THUMBNAIL: 'GENERATE_SINGLE_THUMBNAIL',
  GENERATE_THUMBNAILS: 'GENERATE_THUMBNAILS'
} as const;

export type ClippyClipOption = typeof ClippyClipOption[keyof typeof ClippyClipOption];
export type ClippyClipPreferenceInput = {
  preference: ClippyClipPreferenceType;
  watermarkFilename?: InputMaybe<Scalars['String']['input']>;
};

export const ClippyClipPreferenceType = {
  WATERMARK: 'WATERMARK'
} as const;

export type ClippyClipPreferenceType = typeof ClippyClipPreferenceType[keyof typeof ClippyClipPreferenceType];
export const ClippyFeedType = {
  AWAY: 'AWAY',
  HOME: 'HOME',
  NETWORK: 'NETWORK',
  THREE_D_VIZ: 'THREE_D_VIZ',
  WORLD: 'WORLD'
} as const;

export type ClippyFeedType = typeof ClippyFeedType[keyof typeof ClippyFeedType];
export type ClippyPlayInput = {
  endOffset?: InputMaybe<Scalars['Float']['input']>;
  feedType?: InputMaybe<ClippyFeedType>;
  gamePk: Scalars['Int']['input'];
  playId: Scalars['String']['input'];
  startOffset?: InputMaybe<Scalars['Float']['input']>;
};

export type ClippyThumbnail = {
  __typename?: 'ClippyThumbnail';
  templateUri: Scalars['String']['output'];
  uri: Scalars['String']['output'];
};

export type ClippyVideoClipInput = {
  assetId?: InputMaybe<Scalars['Int']['input']>;
  endOffset?: InputMaybe<Scalars['Float']['input']>;
  feedType?: InputMaybe<ClippyFeedType>;
  gamePk?: InputMaybe<Scalars['Int']['input']>;
  playId?: InputMaybe<Scalars['String']['input']>;
  startOffset?: InputMaybe<Scalars['Float']['input']>;
  type: ClippyVideoType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export const ClippyVideoType = {
  DIRECT: 'DIRECT',
  PLAY: 'PLAY',
  TRANSITION: 'TRANSITION'
} as const;

export type ClippyVideoType = typeof ClippyVideoType[keyof typeof ClippyVideoType];
export const CmsDestination = {
  MILB: 'MILB',
  MLB: 'MLB'
} as const;

export type CmsDestination = typeof CmsDestination[keyof typeof CmsDestination];
export type Comparator = {
  __typename?: 'Comparator';
  displayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<ComparatorType>;
  symbol?: Maybe<Scalars['String']['output']>;
};

export const ComparatorType = {
  EQUALS: 'EQUALS',
  EXACT_MATCH: 'EXACT_MATCH',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_EQUALS: 'GREATER_THAN_EQUALS',
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_EQUALS: 'LESS_THAN_EQUALS',
  LIKE: 'LIKE',
  NOT_EQUALS: 'NOT_EQUALS',
  NOT_LIKE: 'NOT_LIKE'
} as const;

export type ComparatorType = typeof ComparatorType[keyof typeof ComparatorType];
export type CreateCustomClipResponse = {
  __typename?: 'CreateCustomClipResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
  thumbnailUri?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type CreateIssue = {
  comment: Scalars['String']['input'];
  feedType: ClippyFeedType;
  gamePk: Scalars['Int']['input'];
  issueTypes: Array<InputMaybe<IssueType>>;
  playId: Scalars['String']['input'];
  query: Scalars['String']['input'];
  status: IssueStatus;
};

export type CropRatio = {
  __typename?: 'CropRatio';
  value?: Maybe<Scalars['String']['output']>;
};

export type CropRatioInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustomClipInput = {
  audioTracks: Array<AudioRendition>;
  end: Scalars['String']['input'];
  id: Scalars['String']['input'];
  mode: VideoMode;
  source: GameMediaSource;
  start: Scalars['String']['input'];
  thumbnail: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type Cut = {
  __typename?: 'Cut';
  aspectRatio?: Maybe<Scalars['String']['output']>;
  at2x?: Maybe<Scalars['String']['output']>;
  at3x?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type DeleteUserCustomClipResponse = {
  __typename?: 'DeleteUserCustomClipResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DestinationOption = {
  __typename?: 'DestinationOption';
  type: DestinationOptionType;
  value: Scalars['String']['output'];
};

export type DestinationOptionInput = {
  type: DestinationOptionType;
  value: Scalars['String']['input'];
};

export const DestinationOptionType = {
  AUTO_PUBLISH_EXCLUSIONS: 'AUTO_PUBLISH_EXCLUSIONS',
  ENABLE_PUSH_NOTIFICATIONS: 'ENABLE_PUSH_NOTIFICATIONS',
  OMIT_DESCRIPTION: 'OMIT_DESCRIPTION'
} as const;

export type DestinationOptionType = typeof DestinationOptionType[keyof typeof DestinationOptionType];
export const DestinationType = {
  DELTATRE: 'DELTATRE',
  DELTATRE_MILB: 'DELTATRE_MILB',
  EMAIL: 'EMAIL',
  SLACK: 'SLACK',
  TWITTER: 'TWITTER',
  YOUTUBE: 'YOUTUBE'
} as const;

export type DestinationType = typeof DestinationType[keyof typeof DestinationType];
export const EntityType = {
  CONTENT_TAG: 'CONTENT_TAG',
  NONE: 'NONE',
  PLAYER: 'PLAYER',
  SEARCH_TERM: 'SEARCH_TERM',
  TEAM: 'TEAM',
  VENUE: 'VENUE'
} as const;

export type EntityType = typeof EntityType[keyof typeof EntityType];
export const FeedPreference = {
  AWAY: 'AWAY',
  BATTING_TEAM: 'BATTING_TEAM',
  CMS: 'CMS',
  HOME: 'HOME',
  NETWORK: 'NETWORK',
  PITCHING_TEAM: 'PITCHING_TEAM',
  THREE_D_VIZ: 'THREE_D_VIZ',
  WORLD: 'WORLD'
} as const;

export type FeedPreference = typeof FeedPreference[keyof typeof FeedPreference];
export type FieldValue = {
  __typename?: 'FieldValue';
  displayValue?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export const Frequency = {
  ALL: 'ALL',
  ALL_GAMES_END: 'ALL_GAMES_END',
  GAME_END: 'GAME_END',
  HALF_INNING_END: 'HALF_INNING_END',
  INNING_END: 'INNING_END',
  PLAY_END: 'PLAY_END'
} as const;

export type Frequency = typeof Frequency[keyof typeof Frequency];
export type GameMedia = {
  __typename?: 'GameMedia';
  audioTracks: Array<AudioTrack>;
  feedType: VideoFeedType;
  gameDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  playbackUrl?: Maybe<Scalars['String']['output']>;
  source: GameMediaSource;
};

export const GameMediaSource = {
  CONTENT_REGISTRY: 'CONTENT_REGISTRY',
  DIAMOND: 'DIAMOND'
} as const;

export type GameMediaSource = typeof GameMediaSource[keyof typeof GameMediaSource];
export type Image = {
  __typename?: 'Image';
  altText: Scalars['String']['output'];
  cuts: Array<Maybe<Cut>>;
  templateUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type InfoResponse = {
  __typename?: 'InfoResponse';
  count?: Maybe<Scalars['Int']['output']>;
  graph?: Maybe<Scalars['Object']['output']>;
  query: Scalars['String']['output'];
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type Issue = {
  __typename?: 'Issue';
  comment: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  feedType: ClippyFeedType;
  gamePk: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  issueType: IssueType;
  playId: Scalars['String']['output'];
  query: Scalars['String']['output'];
  status: IssueStatus;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export const IssueStatus = {
  ARCHIVED: 'ARCHIVED',
  NEEDS_ATTENTION: 'NEEDS_ATTENTION',
  PENDING: 'PENDING',
  RESOLVED: 'RESOLVED'
} as const;

export type IssueStatus = typeof IssueStatus[keyof typeof IssueStatus];
export const IssueType = {
  BAD_SEARCH_RESULT: 'BAD_SEARCH_RESULT',
  POOR_VIDEO_QUALITY: 'POOR_VIDEO_QUALITY',
  TOO_SHORT_OR_LONG: 'TOO_SHORT_OR_LONG'
} as const;

export type IssueType = typeof IssueType[keyof typeof IssueType];
export const LanguagePreference = {
  EN: 'EN',
  ES: 'ES'
} as const;

export type LanguagePreference = typeof LanguagePreference[keyof typeof LanguagePreference];
export const LimitOption = {
  NONE: 'NONE',
  NUM_PLAYS: 'NUM_PLAYS',
  TIME: 'TIME'
} as const;

export type LimitOption = typeof LimitOption[keyof typeof LimitOption];
export type Link = {
  __typename?: 'Link';
  href?: Maybe<Scalars['String']['output']>;
  rel?: Maybe<Scalars['String']['output']>;
};

export type LinkByType = {
  __typename?: 'LinkByType';
  link: Scalars['String']['output'];
  videoType: Scalars['String']['output'];
};

export const LinkType = {
  CDN: 'CDN',
  DIRECT: 'DIRECT',
  OBFUSCATED: 'OBFUSCATED'
} as const;

export type LinkType = typeof LinkType[keyof typeof LinkType];
export const MediaType = {
  GIF: 'GIF',
  HLS: 'HLS',
  VIDEO: 'VIDEO'
} as const;

export type MediaType = typeof MediaType[keyof typeof MediaType];
export type Mutation = {
  __typename?: 'Mutation';
  createClip?: Maybe<ClipResponse>;
  createCustomClip?: Maybe<CreateCustomClipResponse>;
  createUserClip?: Maybe<Array<Maybe<ClipResponse>>>;
  createUserCustomClip?: Maybe<CreateCustomClipResponse>;
  deleteRule?: Maybe<RuleId>;
  deleteUserCustomClip?: Maybe<DeleteUserCustomClipResponse>;
  outputTypes?: Maybe<ClipOutputTypeResponse>;
  /** @deprecated use createCustomClip */
  postToForge?: Maybe<PostToForgeResponse>;
  putRule?: Maybe<Rule>;
  putUserClip?: Maybe<UserClip>;
  saveIssue?: Maybe<Array<Maybe<Issue>>>;
  saveUserCustomClip?: Maybe<SaveUserCustomClipResponse>;
};


export type MutationCreateClipArgs = {
  clipRequest: ClipRequestInput;
};


export type MutationCreateCustomClipArgs = {
  customClipRequest: CustomClipInput;
};


export type MutationCreateUserClipArgs = {
  clipRequest: UserClipRequestInput;
};


export type MutationCreateUserCustomClipArgs = {
  userCustomClipRequest: UserCustomClipRequestInput;
};


export type MutationDeleteRuleArgs = {
  ruleId: Scalars['Int']['input'];
};


export type MutationDeleteUserCustomClipArgs = {
  clipId: Scalars['Int']['input'];
};


export type MutationOutputTypesArgs = {
  clipId: Scalars['String']['input'];
  clipOutputTypeRequest: Array<InputMaybe<ClipOutputType>>;
};


export type MutationPostToForgeArgs = {
  postToForgeRequest: PostToForgeRequest;
  testGroup?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPutRuleArgs = {
  rule: RuleInput;
};


export type MutationPutUserClipArgs = {
  userClip?: InputMaybe<UserClipInput>;
};


export type MutationSaveIssueArgs = {
  issue: CreateIssue;
};


export type MutationSaveUserCustomClipArgs = {
  userCustomClip?: InputMaybe<SaveUserCustomClipInput>;
};

export type Notification = {
  __typename?: 'Notification';
  destination?: Maybe<Scalars['String']['output']>;
  destinationOptions?: Maybe<Array<Maybe<DestinationOption>>>;
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DestinationType>;
};

export type NotificationInput = {
  destination?: InputMaybe<Scalars['String']['input']>;
  destinationOptions?: InputMaybe<Array<InputMaybe<DestinationOptionInput>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DestinationType>;
};

export const OrderingType = {
  CHRONO: 'CHRONO',
  RANK_FIELD: 'RANK_FIELD'
} as const;

export type OrderingType = typeof OrderingType[keyof typeof OrderingType];
export type PagedPlayDetails = {
  __typename?: 'PagedPlayDetails';
  plays?: Maybe<Array<Maybe<PlayDetails>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PagedRuleResponse = {
  __typename?: 'PagedRuleResponse';
  rules?: Maybe<Array<Maybe<Rule>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PagedUserClip = {
  __typename?: 'PagedUserClip';
  total?: Maybe<Scalars['Int']['output']>;
  userClips?: Maybe<Array<Maybe<UserClip>>>;
};

export type PagedUserCustomClip = {
  __typename?: 'PagedUserCustomClip';
  customClips?: Maybe<Array<Maybe<UserCustomClip>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Play = {
  __typename?: 'Play';
  playId: Scalars['String']['output'];
};

export type PlayDetails = {
  __typename?: 'PlayDetails';
  description?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<SearchFieldValue>>>;
  gameDate?: Maybe<Scalars['String']['output']>;
  gamePk?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  links?: Maybe<Array<Maybe<Link>>>;
  title?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<Array<Maybe<Video>>>;
};

export type PlayInput = {
  playId: Scalars['String']['input'];
};

export type Playback = {
  __typename?: 'Playback';
  mimetype?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  segments?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  url: Scalars['String']['output'];
};

export type PlaybackOption = {
  clipOutputType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PlaybackScenario = {
  __typename?: 'PlaybackScenario';
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PostToForgeRequest = {
  destinationName?: InputMaybe<CmsDestination>;
  durationInSeconds: Scalars['Float']['input'];
  playId?: InputMaybe<Scalars['String']['input']>;
  playbackOptions?: InputMaybe<Array<InputMaybe<PlaybackOption>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  videoDescription: Scalars['String']['input'];
  videoId: Scalars['String']['input'];
  videoTitle: Scalars['String']['input'];
  videoUrl: Scalars['String']['input'];
};

export type PostToForgeResponse = {
  __typename?: 'PostToForgeResponse';
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Query = {
  __typename?: 'Query';
  allUserCustomClips?: Maybe<PagedUserCustomClip>;
  allowedSports: Array<SportInfo>;
  assetAndOffsets?: Maybe<TimeInAssetResponse>;
  assetOffsets?: Maybe<TimeInFeedResponse>;
  availableWatermarks: Array<WatermarkInfo>;
  cerebroEventTypes?: Maybe<Array<CerebroEventType>>;
  cerebroEvents: Array<CerebroEventInfo>;
  clipInfo?: Maybe<UserClip>;
  commonFields?: Maybe<Array<Maybe<SearchFieldValue>>>;
  fields?: Maybe<Array<Maybe<SearchFieldMetadata>>>;
  gameMedia: Array<GameMedia>;
  queryInfo?: Maybe<Array<Maybe<InfoResponse>>>;
  rule?: Maybe<Rule>;
  rules?: Maybe<PagedRuleResponse>;
  search?: Maybe<PagedPlayDetails>;
  types?: Maybe<Array<Maybe<SearchFieldTypeMetadata>>>;
  userClips?: Maybe<PagedUserClip>;
  userCustomClip?: Maybe<UserCustomClip>;
  userCustomClips?: Maybe<PagedUserCustomClip>;
  validateVideoCreationOptions?: Maybe<VideoCreationSelections>;
  videoCreationOptions?: Maybe<Array<Maybe<RestVideoCreationOption>>>;
  videos?: Maybe<Array<Maybe<VideosMetadataResponse>>>;
  workflowDetails?: Maybe<Array<Maybe<VideoWorkflowMetadata>>>;
};


export type QueryAllUserCustomClipsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  gamePk?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<UserCustomClipsSort>;
};


export type QueryAssetAndOffsetsArgs = {
  end: Scalars['String']['input'];
  feedType: VideoFeedType;
  gamePk: Scalars['Int']['input'];
  start: Scalars['String']['input'];
};


export type QueryAssetOffsetsArgs = {
  assetName: Scalars['String']['input'];
  end: Scalars['String']['input'];
  mode?: InputMaybe<VideoMode>;
  start: Scalars['String']['input'];
};


export type QueryCerebroEventsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventTypes: Array<Scalars['Int']['input']>;
  startDate: Scalars['String']['input'];
};


export type QueryClipInfoArgs = {
  id: Scalars['String']['input'];
};


export type QueryCommonFieldsArgs = {
  languagePreference?: InputMaybe<LanguagePreference>;
  plays: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryFieldsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  languagePreference?: InputMaybe<LanguagePreference>;
  searchType?: InputMaybe<SearchType>;
};


export type QueryGameMediaArgs = {
  gameDate?: InputMaybe<Scalars['String']['input']>;
  gamePk: Scalars['Int']['input'];
};


export type QueryQueryInfoArgs = {
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  languagePreference?: InputMaybe<LanguagePreference>;
  queries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryType?: InputMaybe<QueryType>;
};


export type QueryRuleArgs = {
  ruleId: Scalars['Int']['input'];
};


export type QueryRulesArgs = {
  allRules?: InputMaybe<Scalars['Boolean']['input']>;
  createdFrom?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<Frequency>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchArgs = {
  feedPreference?: InputMaybe<FeedPreference>;
  languagePreference?: InputMaybe<LanguagePreference>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkType?: InputMaybe<LinkType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  queryType?: InputMaybe<QueryType>;
  searchType?: InputMaybe<SearchType>;
};


export type QueryUserClipsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserCustomClipArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserCustomClipsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  gamePk?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<UserCustomClipsSort>;
};


export type QueryValidateVideoCreationOptionsArgs = {
  videoCreationSelections: VideoCreationSelectionsInput;
};


export type QueryVideoCreationOptionsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVideosArgs = {
  categories?: InputMaybe<Array<InputMaybe<AssetCategory>>>;
  gamePk: Scalars['Int']['input'];
  linkType?: InputMaybe<LinkType>;
  playId?: InputMaybe<Scalars['String']['input']>;
};

export const QueryType = {
  FREETEXT: 'FREETEXT',
  STRUCTURED: 'STRUCTURED'
} as const;

export type QueryType = typeof QueryType[keyof typeof QueryType];
export type Range = {
  __typename?: 'Range';
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
};

export type RestVideoCreationOption = {
  __typename?: 'RestVideoCreationOption';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  incompatibleOptionIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  name: Scalars['String']['output'];
  optionType?: Maybe<RestVideoCreationOptionType>;
  orderByTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  restrictedToRuleTypes?: Maybe<Array<Maybe<Frequency>>>;
};

export type RestVideoCreationOptionType = {
  __typename?: 'RestVideoCreationOptionType';
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  videoOptionType?: Maybe<VideoOptionType>;
};

export type Rule = {
  __typename?: 'Rule';
  baseQuery: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  frequency: Frequency;
  injectInGameFields?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  notifications?: Maybe<Array<Maybe<Notification>>>;
  ruleId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
  videoOptions?: Maybe<VideoOptions>;
  videoRuleClips?: Maybe<Array<Maybe<VideoRuleClip>>>;
};

export type RuleId = {
  __typename?: 'RuleId';
  ruleId: Scalars['ID']['output'];
};

export type RuleInput = {
  baseQuery: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency: Frequency;
  injectInGameFields?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<Array<InputMaybe<NotificationInput>>>;
  ruleId?: InputMaybe<Scalars['ID']['input']>;
  username: Scalars['String']['input'];
  videoOptions?: InputMaybe<VideoOptionsInput>;
  videoRuleClips?: InputMaybe<Array<InputMaybe<VideoRuleClipInput>>>;
};

export type SaveUserCustomClipInput = {
  assetName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  feedType: VideoFeedType;
  gamePk: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  thumbnailUri?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type SaveUserCustomClipResponse = {
  __typename?: 'SaveUserCustomClipResponse';
  assetName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  feedType: VideoFeedType;
  gamePk: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  startTime: Scalars['String']['output'];
  thumbnailUri?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export const SearchFieldCategory = {
  BATTER: 'BATTER',
  CONTENT: 'CONTENT',
  FIELDER: 'FIELDER',
  GAME: 'GAME',
  GENERAL: 'GENERAL',
  PITCHER: 'PITCHER',
  PLAYMETADATA: 'PLAYMETADATA',
  REVIEW: 'REVIEW',
  RUNNER: 'RUNNER',
  UNKNOWN: 'UNKNOWN'
} as const;

export type SearchFieldCategory = typeof SearchFieldCategory[keyof typeof SearchFieldCategory];
export type SearchFieldMetadata = {
  __typename?: 'SearchFieldMetadata';
  category?: Maybe<SearchFieldCategory>;
  defaultOperator?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['Boolean']['output']>;
  displayName: Scalars['String']['output'];
  entityType: EntityType;
  helperText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  range?: Maybe<Array<Maybe<Range>>>;
  supportsDistinctValues?: Maybe<Scalars['Boolean']['output']>;
  supportsRange?: Maybe<Scalars['Boolean']['output']>;
  type: SearchFieldType;
  typeAheadEnabled?: Maybe<Scalars['Boolean']['output']>;
  unitOfMeasurement?: Maybe<UnitOfMeasurement>;
  values?: Maybe<Array<Maybe<FieldValue>>>;
};

export const SearchFieldType = {
  BOOLEAN: 'BOOLEAN',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  EMPTY: 'EMPTY',
  NUMBER: 'NUMBER',
  STRING: 'STRING',
  UNKNOWN: 'UNKNOWN'
} as const;

export type SearchFieldType = typeof SearchFieldType[keyof typeof SearchFieldType];
export type SearchFieldTypeMetadata = {
  __typename?: 'SearchFieldTypeMetadata';
  name?: Maybe<SearchFieldType>;
  supportedComparators?: Maybe<Array<Maybe<Comparator>>>;
};

export type SearchFieldValue = {
  __typename?: 'SearchFieldValue';
  displayField?: Maybe<SearchFieldMetadata>;
  displayFieldSearchValue?: Maybe<Scalars['String']['output']>;
  displayValue?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export const SearchType = {
  MILB_UNIFIED: 'MILB_UNIFIED',
  PLAYS: 'PLAYS',
  UNIFIED: 'UNIFIED'
} as const;

export type SearchType = typeof SearchType[keyof typeof SearchType];
export type SportInfo = {
  __typename?: 'SportInfo';
  abbreviation: Scalars['String']['output'];
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TimeInAssetResponse = {
  __typename?: 'TimeInAssetResponse';
  assetName: Scalars['String']['output'];
  endSeconds: Scalars['Int']['output'];
  feedType: Scalars['String']['output'];
  startSeconds: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type TimeInFeedResponse = {
  __typename?: 'TimeInFeedResponse';
  endSeconds: Scalars['Int']['output'];
  startSeconds: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type UnitOfMeasurement = {
  __typename?: 'UnitOfMeasurement';
  spanishValue?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type UserClip = {
  __typename?: 'UserClip';
  createdAt?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  options?: Maybe<Array<Maybe<UserClipOptionType>>>;
  plays?: Maybe<Array<Maybe<UserClipPlays>>>;
  searchCategory?: Maybe<Scalars['String']['output']>;
  thumbnailUri: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  transitions?: Maybe<Array<Maybe<UserClipTransitions>>>;
  username: Scalars['String']['output'];
  videoUri: Scalars['String']['output'];
  videos?: Maybe<Array<Maybe<UserClipVideos>>>;
  width: Scalars['Int']['output'];
};

export type UserClipInput = {
  duration?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  options?: InputMaybe<Array<InputMaybe<UserClipOptionType>>>;
  plays?: InputMaybe<Array<InputMaybe<UserClipPlaysInput>>>;
  searchCategory?: InputMaybe<Scalars['String']['input']>;
  thumbnailUri: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  transitions?: InputMaybe<Array<InputMaybe<UserClipTransitionInput>>>;
  username?: InputMaybe<Scalars['String']['input']>;
  videoUri: Scalars['String']['input'];
  videos?: InputMaybe<Array<InputMaybe<UserClipVideoInput>>>;
  width: Scalars['Int']['input'];
};

export const UserClipOptionType = {
  ADD_MLB_WATERMARK: 'ADD_MLB_WATERMARK',
  CROP_FOUR_FIVE: 'CROP_FOUR_FIVE',
  CROP_NINE_SIXTEEN: 'CROP_NINE_SIXTEEN',
  CROP_ONE_ONE: 'CROP_ONE_ONE',
  CROSS_FADE: 'CROSS_FADE',
  UNKNOWN: 'UNKNOWN'
} as const;

export type UserClipOptionType = typeof UserClipOptionType[keyof typeof UserClipOptionType];
export type UserClipPlays = {
  __typename?: 'UserClipPlays';
  clipPosition?: Maybe<Scalars['Int']['output']>;
  endOffset?: Maybe<Scalars['Float']['output']>;
  feedType?: Maybe<ClippyFeedType>;
  id?: Maybe<Scalars['ID']['output']>;
  playDetails?: Maybe<PlayDetails>;
  playId?: Maybe<Scalars['String']['output']>;
  startOffset?: Maybe<Scalars['Float']['output']>;
};

export type UserClipPlaysInput = {
  clipPosition?: InputMaybe<Scalars['Int']['input']>;
  endOffset?: InputMaybe<Scalars['Float']['input']>;
  feedType?: InputMaybe<ClippyFeedType>;
  playId?: InputMaybe<Scalars['String']['input']>;
  startOffset?: InputMaybe<Scalars['Float']['input']>;
};

export type UserClipRequestInput = {
  options: Array<InputMaybe<ClippyClipOption>>;
  outputTypes?: InputMaybe<Array<InputMaybe<ClipOutputType>>>;
  preferences?: InputMaybe<Array<InputMaybe<ClippyClipPreferenceInput>>>;
  requestIdOverride?: InputMaybe<Scalars['String']['input']>;
  videoClips: Array<InputMaybe<ClippyVideoClipInput>>;
};

export type UserClipTransitionInput = {
  assetId?: InputMaybe<Scalars['Int']['input']>;
  clipPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type UserClipTransitions = {
  __typename?: 'UserClipTransitions';
  assetId?: Maybe<Scalars['Int']['output']>;
  clipPosition?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UserClipVideoInput = {
  clipPosition?: InputMaybe<Scalars['Int']['input']>;
  endOffset?: InputMaybe<Scalars['Float']['input']>;
  startOffset?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UserClipVideos = {
  __typename?: 'UserClipVideos';
  clipPosition?: Maybe<Scalars['Int']['output']>;
  endOffset?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  startOffset?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type UserCustomClip = {
  __typename?: 'UserCustomClip';
  assetName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  feedType: VideoFeedType;
  gamePk: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  startTime: Scalars['String']['output'];
  thumbnailUri?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type UserCustomClipRequestInput = {
  assetName: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  mode?: InputMaybe<VideoMode>;
  startTime: Scalars['String']['input'];
  thumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};

export const UserCustomClipsSort = {
  CREATED_AT: 'CREATED_AT',
  GAME_PK: 'GAME_PK',
  UNSORTED: 'UNSORTED'
} as const;

export type UserCustomClipsSort = typeof UserCustomClipsSort[keyof typeof UserCustomClipsSort];
export type Video = {
  __typename?: 'Video';
  feedType?: Maybe<VideoFeedType>;
  image?: Maybe<Image>;
  link?: Maybe<Scalars['String']['output']>;
  playbackScenarios?: Maybe<Array<Maybe<PlaybackScenario>>>;
  rank?: Maybe<Scalars['Int']['output']>;
};


export type VideoImageArgs = {
  aspectRatio?: InputMaybe<AspectRatio>;
  aspectRatios?: InputMaybe<Array<InputMaybe<AspectRatio>>>;
  widths?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export const VideoCreationOption = {
  ADD_INNING_TRANSITIONS: 'ADD_INNING_TRANSITIONS',
  ADD_LAST_PLAY_OF_GAME: 'ADD_LAST_PLAY_OF_GAME',
  ADD_MATCHUP_SPLASH: 'ADD_MATCHUP_SPLASH',
  ADD_MLB_WATERMARK: 'ADD_MLB_WATERMARK',
  CROSS_FADE: 'CROSS_FADE',
  EXTEND_LAST_PLAY_WITH_SLATE: 'EXTEND_LAST_PLAY_WITH_SLATE',
  GENERATE_SINGLE_THUMBNAIL: 'GENERATE_SINGLE_THUMBNAIL',
  GENERATE_THUMBNAILS: 'GENERATE_THUMBNAILS',
  MLB_COPYRIGHT: 'MLB_COPYRIGHT'
} as const;

export type VideoCreationOption = typeof VideoCreationOption[keyof typeof VideoCreationOption];
export type VideoCreationOptionError = {
  __typename?: 'VideoCreationOptionError';
  incompatibleFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  incompatibleValues?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value?: Maybe<Scalars['String']['output']>;
};

export type VideoCreationOptionErrorInput = {
  incompatibleFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  incompatibleValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type VideoCreationSelections = {
  __typename?: 'VideoCreationSelections';
  errors?: Maybe<Array<Maybe<VideoCreationOptionError>>>;
  orderingType?: Maybe<OrderingType>;
  ruleFrequency?: Maybe<Frequency>;
  videoCreationOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VideoCreationSelectionsInput = {
  errors?: InputMaybe<Array<InputMaybe<VideoCreationOptionErrorInput>>>;
  orderingType?: InputMaybe<OrderingType>;
  ruleFrequency?: InputMaybe<Frequency>;
  videoCreationOptions?: InputMaybe<Array<InputMaybe<VideoCreationOption>>>;
};

export const VideoFeedType = {
  AWAY: 'AWAY',
  AWAY_MUX: 'AWAY_MUX',
  AWAY_SHD: 'AWAY_SHD',
  CF: 'CF',
  CMS: 'CMS',
  COACHING_MULTIVIEW: 'COACHING_MULTIVIEW',
  FIRST_BASE_BATTER_SIDEVIEW: 'FIRST_BASE_BATTER_SIDEVIEW',
  FIRST_BASE_PITCHER_SIDEVIEW: 'FIRST_BASE_PITCHER_SIDEVIEW',
  FIRST_BASE_SIDEVIEW: 'FIRST_BASE_SIDEVIEW',
  HIGHHOME: 'HIGHHOME',
  HOME: 'HOME',
  HOME_MUX: 'HOME_MUX',
  HOME_SHD: 'HOME_SHD',
  MIDHOME: 'MIDHOME',
  NATIONAL_MUX: 'NATIONAL_MUX',
  NETWORK: 'NETWORK',
  NETWORK_SHD: 'NETWORK_SHD',
  PACE_OF_GAME_MULTIVIEW: 'PACE_OF_GAME_MULTIVIEW',
  PITCHCAST: 'PITCHCAST',
  REEL: 'REEL',
  REPLAY_MULTIVIEW: 'REPLAY_MULTIVIEW',
  SCOREBOARD: 'SCOREBOARD',
  THIRD_BASE_BATTER_SIDEVIEW: 'THIRD_BASE_BATTER_SIDEVIEW',
  THIRD_BASE_PITCHER_SIDEVIEW: 'THIRD_BASE_PITCHER_SIDEVIEW',
  THIRD_BASE_SIDEVIEW: 'THIRD_BASE_SIDEVIEW',
  THREE_D_VIZ: 'THREE_D_VIZ',
  UNKNOWN: 'UNKNOWN',
  WORLD: 'WORLD'
} as const;

export type VideoFeedType = typeof VideoFeedType[keyof typeof VideoFeedType];
export type VideoMetadataResponse = {
  __typename?: 'VideoMetadataResponse';
  bitrate?: Maybe<Scalars['String']['output']>;
  captions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  category?: Maybe<AssetCategory>;
  feedType: Scalars['String']['output'];
  link: Scalars['String']['output'];
  mediaType?: Maybe<Scalars['String']['output']>;
  playbacks?: Maybe<Array<Maybe<Playback>>>;
  rank: Scalars['Int']['output'];
  thumbnails?: Maybe<Array<Maybe<ClippyThumbnail>>>;
};

export const VideoMode = {
  MILB: 'MILB',
  MLB: 'MLB'
} as const;

export type VideoMode = typeof VideoMode[keyof typeof VideoMode];
export const VideoOptionType = {
  CLIPPY: 'CLIPPY',
  JARED: 'JARED'
} as const;

export type VideoOptionType = typeof VideoOptionType[keyof typeof VideoOptionType];
export type VideoOptions = {
  __typename?: 'VideoOptions';
  captions?: Maybe<Captions>;
  cropRatio?: Maybe<CropRatio>;
  feedExclusions?: Maybe<Array<Maybe<ClippyFeedType>>>;
  feedPreference: FeedPreference;
  limitCount?: Maybe<Scalars['Float']['output']>;
  limitOption?: Maybe<LimitOption>;
  options?: Maybe<Array<Maybe<ClipOption>>>;
  orderingType?: Maybe<OrderingType>;
  strict?: Maybe<Scalars['Boolean']['output']>;
  types?: Maybe<Array<Maybe<MediaType>>>;
  watermark?: Maybe<WatermarkInfo>;
  workflow?: Maybe<VideoWorkflowType>;
};

export type VideoOptionsInput = {
  captions?: InputMaybe<CaptionsInput>;
  cropRatio?: InputMaybe<CropRatioInput>;
  feedExclusions?: InputMaybe<Array<InputMaybe<ClippyFeedType>>>;
  feedPreference: FeedPreference;
  limitCount?: InputMaybe<Scalars['Float']['input']>;
  limitOption?: InputMaybe<LimitOption>;
  options?: InputMaybe<Array<InputMaybe<ClipOptionInput>>>;
  orderingType?: InputMaybe<OrderingType>;
  strict?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<InputMaybe<MediaType>>>;
  watermark?: InputMaybe<WatermarkInput>;
  workflow?: InputMaybe<VideoWorkflowType>;
};

export type VideoRuleClip = {
  __typename?: 'VideoRuleClip';
  clipId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  plays?: Maybe<Array<Maybe<Play>>>;
  ruleId?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  uri: Scalars['String']['output'];
};

export type VideoRuleClipInput = {
  clipId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  plays?: InputMaybe<Array<InputMaybe<PlayInput>>>;
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  uri: Scalars['String']['input'];
};

export type VideoTransitionInsertInput = {
  insertAt?: InputMaybe<Scalars['Int']['input']>;
  transitionAssetId?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoWorkflowMetadata = {
  __typename?: 'VideoWorkflowMetadata';
  description?: Maybe<Scalars['String']['output']>;
  workflowName?: Maybe<Scalars['String']['output']>;
};

export const VideoWorkflowType = {
  CAPTURE_REVIEW: 'CAPTURE_REVIEW',
  HD_OVERRIDE: 'HD_OVERRIDE',
  STANDARD: 'STANDARD'
} as const;

export type VideoWorkflowType = typeof VideoWorkflowType[keyof typeof VideoWorkflowType];
export type VideosMetadataResponse = {
  __typename?: 'VideosMetadataResponse';
  playId: Scalars['String']['output'];
  videos?: Maybe<Array<Maybe<VideoMetadataResponse>>>;
};


export type VideosMetadataResponseVideosArgs = {
  feedTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WatermarkInfo = {
  __typename?: 'WatermarkInfo';
  filename: Scalars['String']['output'];
};

export type WatermarkInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
};

export type PostToForgeMutationVariables = Exact<{
  postToForgeRequest: PostToForgeRequest;
}>;


export type PostToForgeMutation = { __typename?: 'Mutation', postToForge?: { __typename?: 'PostToForgeResponse', success?: boolean | null, statusCode?: number | null, message?: string | null } | null };

export type CreateUserClipMutationVariables = Exact<{
  clipRequest: UserClipRequestInput;
}>;


export type CreateUserClipMutation = { __typename?: 'Mutation', createUserClip?: Array<{ __typename?: 'ClipResponse', success?: boolean | null, uri: string, id: string, width: number, height: number, durationInSeconds: number, warnings?: Array<string | null> | null, errors?: Array<string | null> | null, clipOutputType: ClipOutputType, thumbnails: Array<{ __typename?: 'ClippyThumbnail', uri: string } | null> } | null> | null };

export type PutUserClipMutationVariables = Exact<{
  userClip: UserClipInput;
}>;


export type PutUserClipMutation = { __typename?: 'Mutation', putUserClip?: { __typename?: 'UserClip', id: string } | null };

export type DeleteUserCustomClipMutationVariables = Exact<{
  clipId: Scalars['Int']['input'];
}>;


export type DeleteUserCustomClipMutation = { __typename?: 'Mutation', deleteUserCustomClip?: { __typename?: 'DeleteUserCustomClipResponse', success?: boolean | null } | null };

export type CreateCustomClipMutationVariables = Exact<{
  customClipRequest: CustomClipInput;
}>;


export type CreateCustomClipMutation = { __typename?: 'Mutation', createCustomClip?: { __typename?: 'CreateCustomClipResponse', success?: boolean | null, videoUrl?: string | null, thumbnailUri?: string | null } | null };

export type SaveUserCustomClipMutationVariables = Exact<{
  userCustomClip: SaveUserCustomClipInput;
}>;


export type SaveUserCustomClipMutation = { __typename?: 'Mutation', saveUserCustomClip?: { __typename?: 'SaveUserCustomClipResponse', id: string } | null };

export type OutputTypesMutationVariables = Exact<{
  clipId: Scalars['String']['input'];
}>;


export type OutputTypesMutation = { __typename?: 'Mutation', outputTypes?: { __typename?: 'ClipOutputTypeResponse', linksByType: Array<{ __typename?: 'LinkByType', link: string, videoType: string } | null> } | null };

export type CommonFieldsQueryVariables = Exact<{
  plays: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CommonFieldsQuery = { __typename?: 'Query', commonFields?: Array<{ __typename?: 'SearchFieldValue', displayFieldSearchValue?: string | null, displayValue?: string | null, name?: string | null, value?: string | null } | null> | null };

export type AvailableWatermarksQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableWatermarksQuery = { __typename?: 'Query', availableWatermarks: Array<{ __typename?: 'WatermarkInfo', filename: string }> };

export type AllowedSportsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllowedSportsQuery = { __typename?: 'Query', allowedSports: Array<{ __typename?: 'SportInfo', abbreviation: string, code: string, id: number, name: string }> };

export type SearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  feedPreference?: InputMaybe<FeedPreference>;
  languagePreference?: InputMaybe<LanguagePreference>;
  queryType?: InputMaybe<QueryType>;
  searchType?: InputMaybe<SearchType>;
}>;


export type SearchQuery = { __typename?: 'Query', search?: { __typename?: 'PagedPlayDetails', total?: number | null, plays?: Array<{ __typename?: 'PlayDetails', id: string, gamePk?: number | null, gameDate?: string | null, description?: string | null, title?: string | null, fields?: Array<{ __typename?: 'SearchFieldValue', name?: string | null, value?: string | null, displayValue?: string | null, displayFieldSearchValue?: string | null } | null> | null, videos?: Array<{ __typename?: 'Video', feedType?: VideoFeedType | null, link?: string | null, rank?: number | null, image?: { __typename?: 'Image', title: string, altText: string, templateUrl?: string | null, cuts: Array<{ __typename?: 'Cut', at2x?: string | null } | null> } | null } | null> | null } | null> | null } | null };

export type UserCustomClipsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<UserCustomClipsSort>;
  description?: InputMaybe<Scalars['String']['input']>;
  gamePk?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserCustomClipsQuery = { __typename?: 'Query', userCustomClips?: { __typename?: 'PagedUserCustomClip', total?: number | null, customClips?: Array<{ __typename?: 'UserCustomClip', id?: string | null, gamePk: number, feedType: VideoFeedType, userName: string, url: string, thumbnailUri?: string | null, description?: string | null, startTime: string, endTime: string } | null> | null } | null };

export type AllUserCustomClipsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<UserCustomClipsSort>;
  description?: InputMaybe<Scalars['String']['input']>;
  gamePk?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllUserCustomClipsQuery = { __typename?: 'Query', allUserCustomClips?: { __typename?: 'PagedUserCustomClip', total?: number | null, customClips?: Array<{ __typename?: 'UserCustomClip', id?: string | null, gamePk: number, feedType: VideoFeedType, userName: string, url: string, thumbnailUri?: string | null, description?: string | null, startTime: string, endTime: string } | null> | null } | null };

export type UserClipsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserClipsQuery = { __typename?: 'Query', userClips?: { __typename?: 'PagedUserClip', total?: number | null, userClips?: Array<{ __typename?: 'UserClip', id: string, title?: string | null, thumbnailUri: string, createdAt?: string | null, duration?: string | null, options?: Array<UserClipOptionType | null> | null, videoUri: string, username: string, plays?: Array<{ __typename?: 'UserClipPlays', id?: string | null, playId?: string | null, clipPosition?: number | null, playDetails?: { __typename?: 'PlayDetails', gamePk?: number | null, description?: string | null } | null } | null> | null } | null> | null } | null };

export type GameMediaQueryVariables = Exact<{
  gamePk: Scalars['Int']['input'];
  gameDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type GameMediaQuery = { __typename?: 'Query', gameMedia: Array<{ __typename?: 'GameMedia', id: string, source: GameMediaSource, name: string, feedType: VideoFeedType, playbackUrl?: string | null, gameDate?: string | null, audioTracks: Array<{ __typename?: 'AudioTrack', language: string, name: string, renditionName: string, trackType: string }> }> };

export type CerebroEventsQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  eventTypes?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type CerebroEventsQuery = { __typename?: 'Query', cerebroEvents: Array<{ __typename?: 'CerebroEventInfo', assetId: number, playbackUrl?: string | null, title?: string | null, description?: string | null, programStartTime?: string | null, programEndTime?: string | null, thumbnailUrl?: string | null }> };

export type PlayResultNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayResultNamesQuery = { __typename?: 'Query', fields?: Array<{ __typename?: 'SearchFieldMetadata', id: string, values?: Array<{ __typename?: 'FieldValue', value?: string | null, displayValue?: string | null } | null> | null } | null> | null };

export type AssetOffsetsQueryVariables = Exact<{
  assetName: Scalars['String']['input'];
  start: Scalars['String']['input'];
  end: Scalars['String']['input'];
  mode?: InputMaybe<VideoMode>;
}>;


export type AssetOffsetsQuery = { __typename?: 'Query', assetOffsets?: { __typename?: 'TimeInFeedResponse', startSeconds: number, endSeconds: number, success: boolean } | null };

export type RuleFragmentFragment = { __typename?: 'Rule', ruleId: string, name: string, username: string, frequency: Frequency, enabled?: boolean | null };

export type PutRuleMutationVariables = Exact<{
  rule: RuleInput;
}>;


export type PutRuleMutation = { __typename?: 'Mutation', putRule?: { __typename?: 'Rule', baseQuery: string, injectInGameFields?: boolean | null, ruleId: string, name: string, username: string, frequency: Frequency, enabled?: boolean | null, videoOptions?: { __typename?: 'VideoOptions', types?: Array<MediaType | null> | null, feedExclusions?: Array<ClippyFeedType | null> | null, feedPreference: FeedPreference, limitCount?: number | null, limitOption?: LimitOption | null, orderingType?: OrderingType | null, workflow?: VideoWorkflowType | null, captions?: { __typename?: 'Captions', language?: string | null } | null, cropRatio?: { __typename?: 'CropRatio', value?: string | null } | null, watermark?: { __typename?: 'WatermarkInfo', filename: string } | null, options?: Array<{ __typename?: 'ClipOption', name?: string | null, value?: string | null } | null> | null } | null, notifications?: Array<{ __typename?: 'Notification', type?: DestinationType | null, destination?: string | null, message?: string | null, destinationOptions?: Array<{ __typename?: 'DestinationOption', type: DestinationOptionType, value: string } | null> | null } | null> | null } | null };

export type DeleteRuleMutationVariables = Exact<{
  ruleId: Scalars['Int']['input'];
}>;


export type DeleteRuleMutation = { __typename?: 'Mutation', deleteRule?: { __typename?: 'RuleId', ruleId: string } | null };

export type RuleQueryVariables = Exact<{
  ruleId: Scalars['Int']['input'];
}>;


export type RuleQuery = { __typename?: 'Query', rule?: { __typename?: 'Rule', baseQuery: string, injectInGameFields?: boolean | null, ruleId: string, name: string, username: string, frequency: Frequency, enabled?: boolean | null, videoOptions?: { __typename?: 'VideoOptions', types?: Array<MediaType | null> | null, feedExclusions?: Array<ClippyFeedType | null> | null, feedPreference: FeedPreference, limitCount?: number | null, limitOption?: LimitOption | null, orderingType?: OrderingType | null, workflow?: VideoWorkflowType | null, captions?: { __typename?: 'Captions', language?: string | null } | null, cropRatio?: { __typename?: 'CropRatio', value?: string | null } | null, watermark?: { __typename?: 'WatermarkInfo', filename: string } | null, options?: Array<{ __typename?: 'ClipOption', name?: string | null, value?: string | null } | null> | null } | null, notifications?: Array<{ __typename?: 'Notification', type?: DestinationType | null, destination?: string | null, message?: string | null, destinationOptions?: Array<{ __typename?: 'DestinationOption', type: DestinationOptionType, value: string } | null> | null } | null> | null } | null };

export type RulesQueryVariables = Exact<{
  createdFrom?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<Frequency>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  allRules?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RulesQuery = { __typename?: 'Query', rules?: { __typename?: 'PagedRuleResponse', total?: number | null, rules?: Array<{ __typename?: 'Rule', createdAt?: string | null, updatedAt?: string | null, ruleId: string, name: string, username: string, frequency: Frequency, enabled?: boolean | null } | null> | null } | null };

export type WorkflowDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkflowDetailsQuery = { __typename?: 'Query', workflowDetails?: Array<{ __typename?: 'VideoWorkflowMetadata', description?: string | null, workflowName?: string | null } | null> | null };

export type ValidateBaseQueryQueryVariables = Exact<{
  baseQuery: Scalars['String']['input'];
}>;


export type ValidateBaseQueryQuery = { __typename?: 'Query', queryInfo?: Array<{ __typename?: 'InfoResponse', valid?: boolean | null } | null> | null };

export type VideoCreationOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type VideoCreationOptionsQuery = { __typename?: 'Query', videoCreationOptions?: Array<{ __typename?: 'RestVideoCreationOption', description: string, displayName: string, id: string, name: string } | null> | null };

export type ValidateVideoCreationOptionsQueryVariables = Exact<{
  videoCreationSelections: VideoCreationSelectionsInput;
}>;


export type ValidateVideoCreationOptionsQuery = { __typename?: 'Query', validateVideoCreationOptions?: { __typename?: 'VideoCreationSelections', errors?: Array<{ __typename?: 'VideoCreationOptionError', incompatibleFields?: Array<string | null> | null, incompatibleValues?: Array<string | null> | null, value?: string | null } | null> | null } | null };

export type QueryInfoQueryVariables = Exact<{
  queries: Array<Scalars['String']['input']> | Scalars['String']['input'];
  queryType?: InputMaybe<QueryType>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type QueryInfoQuery = { __typename?: 'Query', queryInfo?: Array<{ __typename?: 'InfoResponse', valid?: boolean | null, query: string, graph?: any | null } | null> | null };

export const RuleFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RuleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Rule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ruleId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]} as unknown as DocumentNode<RuleFragmentFragment, unknown>;
export const PostToForgeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"postToForge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postToForgeRequest"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostToForgeRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postToForge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"postToForgeRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postToForgeRequest"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<PostToForgeMutation, PostToForgeMutationVariables>;
export const CreateUserClipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUserClip"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clipRequest"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserClipRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserClip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clipRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clipRequest"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"durationInSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warnings"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"clipOutputType"}}]}}]}}]} as unknown as DocumentNode<CreateUserClipMutation, CreateUserClipMutationVariables>;
export const PutUserClipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"putUserClip"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userClip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserClipInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"putUserClip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userClip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userClip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PutUserClipMutation, PutUserClipMutationVariables>;
export const DeleteUserCustomClipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteUserCustomClip"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserCustomClip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteUserCustomClipMutation, DeleteUserCustomClipMutationVariables>;
export const CreateCustomClipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCustomClip"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customClipRequest"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomClipInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomClip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customClipRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customClipRequest"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUri"}}]}}]}}]} as unknown as DocumentNode<CreateCustomClipMutation, CreateCustomClipMutationVariables>;
export const SaveUserCustomClipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveUserCustomClip"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userCustomClip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveUserCustomClipInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveUserCustomClip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userCustomClip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userCustomClip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SaveUserCustomClipMutation, SaveUserCustomClipMutationVariables>;
export const OutputTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"outputTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outputTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clipId"}}},{"kind":"Argument","name":{"kind":"Name","value":"clipOutputTypeRequest"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MP4"},{"kind":"EnumValue","value":"HLS"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linksByType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"videoType"}}]}}]}}]}}]} as unknown as DocumentNode<OutputTypesMutation, OutputTypesMutationVariables>;
export const CommonFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"commonFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plays"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commonFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"plays"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plays"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayFieldSearchValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<CommonFieldsQuery, CommonFieldsQueryVariables>;
export const AvailableWatermarksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"availableWatermarks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableWatermarks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}}]} as unknown as DocumentNode<AvailableWatermarksQuery, AvailableWatermarksQueryVariables>;
export const AllowedSportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allowedSports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowedSports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AllowedSportsQuery, AllowedSportsQueryVariables>;
export const SearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"search"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedPreference"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FeedPreference"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languagePreference"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguagePreference"}},"defaultValue":{"kind":"EnumValue","value":"EN"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queryType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryType"}},"defaultValue":{"kind":"EnumValue","value":"STRUCTURED"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchType"}},"defaultValue":{"kind":"EnumValue","value":"UNIFIED"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"feedPreference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedPreference"}}},{"kind":"Argument","name":{"kind":"Name","value":"languagePreference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languagePreference"}}},{"kind":"Argument","name":{"kind":"Name","value":"queryType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queryType"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"gameDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"displayValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayFieldSearchValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"templateUrl"}},{"kind":"Field","name":{"kind":"Name","value":"cuts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at2x"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<SearchQuery, SearchQueryVariables>;
export const UserCustomClipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userCustomClips"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCustomClipsSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCustomClips"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"gamePk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customClips"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUri"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<UserCustomClipsQuery, UserCustomClipsQueryVariables>;
export const AllUserCustomClipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allUserCustomClips"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCustomClipsSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allUserCustomClips"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"gamePk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customClips"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUri"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<AllUserCustomClipsQuery, AllUserCustomClipsQueryVariables>;
export const UserClipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userClips"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userClips"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userClips"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUri"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"videoUri"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"plays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"playId"}},{"kind":"Field","name":{"kind":"Name","value":"clipPosition"}},{"kind":"Field","name":{"kind":"Name","value":"playDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<UserClipsQuery, UserClipsQueryVariables>;
export const GameMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"gameMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gameDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gamePk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}}},{"kind":"Argument","name":{"kind":"Name","value":"gameDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gameDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"playbackUrl"}},{"kind":"Field","name":{"kind":"Name","value":"gameDate"}},{"kind":"Field","name":{"kind":"Name","value":"audioTracks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"renditionName"}},{"kind":"Field","name":{"kind":"Name","value":"trackType"}}]}}]}}]}}]} as unknown as DocumentNode<GameMediaQuery, GameMediaQueryVariables>;
export const CerebroEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"cerebroEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"IntValue","value":"1"},{"kind":"IntValue","value":"9"},{"kind":"IntValue","value":"14"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cerebroEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventTypes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"playbackUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"programStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"programEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}}]}}]} as unknown as DocumentNode<CerebroEventsQuery, CerebroEventsQueryVariables>;
export const PlayResultNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"playResultNames"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"ListValue","values":[{"kind":"IntValue","value":"7"},{"kind":"IntValue","value":"177"},{"kind":"IntValue","value":"31"},{"kind":"IntValue","value":"133"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"displayValue"}}]}}]}}]}}]} as unknown as DocumentNode<PlayResultNamesQuery, PlayResultNamesQueryVariables>;
export const AssetOffsetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assetOffsets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetOffsets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetName"}}},{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"Argument","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"Argument","name":{"kind":"Name","value":"mode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"endSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<AssetOffsetsQuery, AssetOffsetsQueryVariables>;
export const PutRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"putRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rule"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RuleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"putRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"rule"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rule"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RuleFragment"}},{"kind":"Field","name":{"kind":"Name","value":"baseQuery"}},{"kind":"Field","name":{"kind":"Name","value":"injectInGameFields"}},{"kind":"Field","name":{"kind":"Name","value":"videoOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"feedExclusions"}},{"kind":"Field","name":{"kind":"Name","value":"feedPreference"}},{"kind":"Field","name":{"kind":"Name","value":"limitCount"}},{"kind":"Field","name":{"kind":"Name","value":"limitOption"}},{"kind":"Field","name":{"kind":"Name","value":"orderingType"}},{"kind":"Field","name":{"kind":"Name","value":"workflow"}},{"kind":"Field","name":{"kind":"Name","value":"captions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cropRatio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"watermark"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"destination"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"destinationOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RuleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Rule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ruleId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]} as unknown as DocumentNode<PutRuleMutation, PutRuleMutationVariables>;
export const DeleteRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ruleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ruleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ruleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ruleId"}}]}}]}}]} as unknown as DocumentNode<DeleteRuleMutation, DeleteRuleMutationVariables>;
export const RuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"rule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ruleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ruleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ruleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RuleFragment"}},{"kind":"Field","name":{"kind":"Name","value":"baseQuery"}},{"kind":"Field","name":{"kind":"Name","value":"injectInGameFields"}},{"kind":"Field","name":{"kind":"Name","value":"videoOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"feedExclusions"}},{"kind":"Field","name":{"kind":"Name","value":"feedPreference"}},{"kind":"Field","name":{"kind":"Name","value":"limitCount"}},{"kind":"Field","name":{"kind":"Name","value":"limitOption"}},{"kind":"Field","name":{"kind":"Name","value":"orderingType"}},{"kind":"Field","name":{"kind":"Name","value":"workflow"}},{"kind":"Field","name":{"kind":"Name","value":"captions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cropRatio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"watermark"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"destination"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"destinationOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RuleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Rule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ruleId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]} as unknown as DocumentNode<RuleQuery, RuleQueryVariables>;
export const RulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"rules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frequency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Frequency"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allRules"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createdFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}},{"kind":"Argument","name":{"kind":"Name","value":"frequency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frequency"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"allRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RuleFragment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RuleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Rule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ruleId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]} as unknown as DocumentNode<RulesQuery, RulesQueryVariables>;
export const WorkflowDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"workflowDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"workflowName"}}]}}]}}]} as unknown as DocumentNode<WorkflowDetailsQuery, WorkflowDetailsQueryVariables>;
export const ValidateBaseQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"validateBaseQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseQuery"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"queries"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"baseQuery"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valid"}}]}}]}}]} as unknown as DocumentNode<ValidateBaseQueryQuery, ValidateBaseQueryQueryVariables>;
export const VideoCreationOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"videoCreationOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoCreationOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<VideoCreationOptionsQuery, VideoCreationOptionsQueryVariables>;
export const ValidateVideoCreationOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"validateVideoCreationOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"videoCreationSelections"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VideoCreationSelectionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateVideoCreationOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"videoCreationSelections"},"value":{"kind":"Variable","name":{"kind":"Name","value":"videoCreationSelections"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incompatibleFields"}},{"kind":"Field","name":{"kind":"Name","value":"incompatibleValues"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<ValidateVideoCreationOptionsQuery, ValidateVideoCreationOptionsQueryVariables>;
export const QueryInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"queryInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queries"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queryType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryType"}},"defaultValue":{"kind":"EnumValue","value":"FREETEXT"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"queries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queries"}}},{"kind":"Argument","name":{"kind":"Name","value":"queryType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queryType"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCount"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valid"}},{"kind":"Field","name":{"kind":"Name","value":"query"}},{"kind":"Field","name":{"kind":"Name","value":"graph"}}]}}]}}]} as unknown as DocumentNode<QueryInfoQuery, QueryInfoQueryVariables>;

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPostToForgeMutation(
 *   ({ query, variables }) => {
 *     const { postToForgeRequest } = variables;
 *     return HttpResponse.json({
 *       data: { postToForge }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPostToForgeMutation = (resolver: GraphQLResponseResolver<PostToForgeMutation, PostToForgeMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<PostToForgeMutation, PostToForgeMutationVariables>(
    'postToForge',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateUserClipMutation(
 *   ({ query, variables }) => {
 *     const { clipRequest } = variables;
 *     return HttpResponse.json({
 *       data: { createUserClip }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateUserClipMutation = (resolver: GraphQLResponseResolver<CreateUserClipMutation, CreateUserClipMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateUserClipMutation, CreateUserClipMutationVariables>(
    'createUserClip',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPutUserClipMutation(
 *   ({ query, variables }) => {
 *     const { userClip } = variables;
 *     return HttpResponse.json({
 *       data: { putUserClip }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPutUserClipMutation = (resolver: GraphQLResponseResolver<PutUserClipMutation, PutUserClipMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<PutUserClipMutation, PutUserClipMutationVariables>(
    'putUserClip',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteUserCustomClipMutation(
 *   ({ query, variables }) => {
 *     const { clipId } = variables;
 *     return HttpResponse.json({
 *       data: { deleteUserCustomClip }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteUserCustomClipMutation = (resolver: GraphQLResponseResolver<DeleteUserCustomClipMutation, DeleteUserCustomClipMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteUserCustomClipMutation, DeleteUserCustomClipMutationVariables>(
    'deleteUserCustomClip',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateCustomClipMutation(
 *   ({ query, variables }) => {
 *     const { customClipRequest } = variables;
 *     return HttpResponse.json({
 *       data: { createCustomClip }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateCustomClipMutation = (resolver: GraphQLResponseResolver<CreateCustomClipMutation, CreateCustomClipMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateCustomClipMutation, CreateCustomClipMutationVariables>(
    'createCustomClip',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSaveUserCustomClipMutation(
 *   ({ query, variables }) => {
 *     const { userCustomClip } = variables;
 *     return HttpResponse.json({
 *       data: { saveUserCustomClip }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSaveUserCustomClipMutation = (resolver: GraphQLResponseResolver<SaveUserCustomClipMutation, SaveUserCustomClipMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SaveUserCustomClipMutation, SaveUserCustomClipMutationVariables>(
    'saveUserCustomClip',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockOutputTypesMutation(
 *   ({ query, variables }) => {
 *     const { clipId } = variables;
 *     return HttpResponse.json({
 *       data: { outputTypes }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockOutputTypesMutation = (resolver: GraphQLResponseResolver<OutputTypesMutation, OutputTypesMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<OutputTypesMutation, OutputTypesMutationVariables>(
    'outputTypes',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCommonFieldsQuery(
 *   ({ query, variables }) => {
 *     const { plays } = variables;
 *     return HttpResponse.json({
 *       data: { commonFields }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCommonFieldsQuery = (resolver: GraphQLResponseResolver<CommonFieldsQuery, CommonFieldsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CommonFieldsQuery, CommonFieldsQueryVariables>(
    'commonFields',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAvailableWatermarksQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { availableWatermarks }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAvailableWatermarksQuery = (resolver: GraphQLResponseResolver<AvailableWatermarksQuery, AvailableWatermarksQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AvailableWatermarksQuery, AvailableWatermarksQueryVariables>(
    'availableWatermarks',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAllowedSportsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { allowedSports }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAllowedSportsQuery = (resolver: GraphQLResponseResolver<AllowedSportsQuery, AllowedSportsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AllowedSportsQuery, AllowedSportsQueryVariables>(
    'allowedSports',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSearchQuery(
 *   ({ query, variables }) => {
 *     const { query, limit, page, feedPreference, languagePreference, queryType, searchType } = variables;
 *     return HttpResponse.json({
 *       data: { search }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSearchQuery = (resolver: GraphQLResponseResolver<SearchQuery, SearchQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SearchQuery, SearchQueryVariables>(
    'search',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUserCustomClipsQuery(
 *   ({ query, variables }) => {
 *     const { limit, page, sortOrder, description, gamePk } = variables;
 *     return HttpResponse.json({
 *       data: { userCustomClips }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUserCustomClipsQuery = (resolver: GraphQLResponseResolver<UserCustomClipsQuery, UserCustomClipsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<UserCustomClipsQuery, UserCustomClipsQueryVariables>(
    'userCustomClips',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAllUserCustomClipsQuery(
 *   ({ query, variables }) => {
 *     const { limit, page, sortOrder, description, gamePk } = variables;
 *     return HttpResponse.json({
 *       data: { allUserCustomClips }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAllUserCustomClipsQuery = (resolver: GraphQLResponseResolver<AllUserCustomClipsQuery, AllUserCustomClipsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AllUserCustomClipsQuery, AllUserCustomClipsQueryVariables>(
    'allUserCustomClips',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUserClipsQuery(
 *   ({ query, variables }) => {
 *     const { limit, page, sortBy, title } = variables;
 *     return HttpResponse.json({
 *       data: { userClips }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUserClipsQuery = (resolver: GraphQLResponseResolver<UserClipsQuery, UserClipsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<UserClipsQuery, UserClipsQueryVariables>(
    'userClips',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGameMediaQuery(
 *   ({ query, variables }) => {
 *     const { gamePk, gameDate } = variables;
 *     return HttpResponse.json({
 *       data: { gameMedia }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGameMediaQuery = (resolver: GraphQLResponseResolver<GameMediaQuery, GameMediaQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GameMediaQuery, GameMediaQueryVariables>(
    'gameMedia',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCerebroEventsQuery(
 *   ({ query, variables }) => {
 *     const { startDate, eventTypes } = variables;
 *     return HttpResponse.json({
 *       data: { cerebroEvents }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCerebroEventsQuery = (resolver: GraphQLResponseResolver<CerebroEventsQuery, CerebroEventsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CerebroEventsQuery, CerebroEventsQueryVariables>(
    'cerebroEvents',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPlayResultNamesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { fields }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPlayResultNamesQuery = (resolver: GraphQLResponseResolver<PlayResultNamesQuery, PlayResultNamesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PlayResultNamesQuery, PlayResultNamesQueryVariables>(
    'playResultNames',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAssetOffsetsQuery(
 *   ({ query, variables }) => {
 *     const { assetName, start, end, mode } = variables;
 *     return HttpResponse.json({
 *       data: { assetOffsets }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAssetOffsetsQuery = (resolver: GraphQLResponseResolver<AssetOffsetsQuery, AssetOffsetsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AssetOffsetsQuery, AssetOffsetsQueryVariables>(
    'assetOffsets',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPutRuleMutation(
 *   ({ query, variables }) => {
 *     const { rule } = variables;
 *     return HttpResponse.json({
 *       data: { putRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPutRuleMutation = (resolver: GraphQLResponseResolver<PutRuleMutation, PutRuleMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<PutRuleMutation, PutRuleMutationVariables>(
    'putRule',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteRuleMutation(
 *   ({ query, variables }) => {
 *     const { ruleId } = variables;
 *     return HttpResponse.json({
 *       data: { deleteRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteRuleMutation = (resolver: GraphQLResponseResolver<DeleteRuleMutation, DeleteRuleMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteRuleMutation, DeleteRuleMutationVariables>(
    'deleteRule',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRuleQuery(
 *   ({ query, variables }) => {
 *     const { ruleId } = variables;
 *     return HttpResponse.json({
 *       data: { rule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRuleQuery = (resolver: GraphQLResponseResolver<RuleQuery, RuleQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RuleQuery, RuleQueryVariables>(
    'rule',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRulesQuery(
 *   ({ query, variables }) => {
 *     const { createdFrom, enabled, frequency, limit, page, allRules } = variables;
 *     return HttpResponse.json({
 *       data: { rules }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRulesQuery = (resolver: GraphQLResponseResolver<RulesQuery, RulesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RulesQuery, RulesQueryVariables>(
    'rules',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkflowDetailsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { workflowDetails }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkflowDetailsQuery = (resolver: GraphQLResponseResolver<WorkflowDetailsQuery, WorkflowDetailsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkflowDetailsQuery, WorkflowDetailsQueryVariables>(
    'workflowDetails',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockValidateBaseQueryQuery(
 *   ({ query, variables }) => {
 *     const { baseQuery } = variables;
 *     return HttpResponse.json({
 *       data: { queryInfo }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockValidateBaseQueryQuery = (resolver: GraphQLResponseResolver<ValidateBaseQueryQuery, ValidateBaseQueryQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ValidateBaseQueryQuery, ValidateBaseQueryQueryVariables>(
    'validateBaseQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockVideoCreationOptionsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { videoCreationOptions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockVideoCreationOptionsQuery = (resolver: GraphQLResponseResolver<VideoCreationOptionsQuery, VideoCreationOptionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<VideoCreationOptionsQuery, VideoCreationOptionsQueryVariables>(
    'videoCreationOptions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockValidateVideoCreationOptionsQuery(
 *   ({ query, variables }) => {
 *     const { videoCreationSelections } = variables;
 *     return HttpResponse.json({
 *       data: { validateVideoCreationOptions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockValidateVideoCreationOptionsQuery = (resolver: GraphQLResponseResolver<ValidateVideoCreationOptionsQuery, ValidateVideoCreationOptionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ValidateVideoCreationOptionsQuery, ValidateVideoCreationOptionsQueryVariables>(
    'validateVideoCreationOptions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockQueryInfoQuery(
 *   ({ query, variables }) => {
 *     const { queries, queryType, includeCount } = variables;
 *     return HttpResponse.json({
 *       data: { queryInfo }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockQueryInfoQuery = (resolver: GraphQLResponseResolver<QueryInfoQuery, QueryInfoQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<QueryInfoQuery, QueryInfoQueryVariables>(
    'queryInfo',
    resolver,
    options
  )
